import styled from 'styled-components';

export const Content = styled.div`
  display: grid;
  gap: 8px;
  min-width: 190px;
  font-size: 13px;
  line-height: 1.4;
`;

export const Group = styled.div`
  display: grid;
  gap: 6px;
`;

export const GroupLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  opacity: 0.7;
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font: inherit;
`;

export const OptionText = styled.span`
  font: inherit;
`;

export const ThresholdControl = styled.div<{ $disabled?: boolean }>`
  --threshold-position: 0%;

  width: 150px;
  padding-top: 2px;
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};

  input[type='range'] {
    width: 100%;
    height: 18px;
    margin: 0;
    accent-color: ${({ theme }) => theme.teal};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  }

  .threshold-value {
    width: max-content;
    min-width: 24px;
    transform: translateX(-50%);
    margin-left: var(--threshold-position);
    font-size: 11px;
    line-height: 1;
    opacity: 0.8;
    text-align: center;
    white-space: nowrap;
  }
`;

export const ThresholdHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font: inherit;

  button {
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.8;
  }
`;
